// Mock data for demonstration
const initialData = {
  circles: [
    {
      id: 1,
      name: 'Family',
      color: '#FF6B6B',
      members: 8,
      description: 'Immediate and extended family members',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 1, name: 'John Doe', role: 'Father', connections: [{ to: 0, type: 'parent' }], level:1, hasConnections: true },
        { id: 2, name: 'Jane Smith', role: 'Mother', connections: [{ to: 0, type: 'parent' }],  level:1,hasConnections: true },
        { id: 3, name: 'Mike Johnson', role: 'Brother', connections: [{ to: 0, type: 'sibling' }], level:1, hasConnections: true },
        { id: 4, name: 'Sarah Johnson', role: 'Sister', connections: [{ to: 0, type: 'sibling' }],  level:1,hasConnections: true },
        { id: 5, name: 'Robert Doe', role: 'Grandfather', connections: [{ to: 1, type: 'parent' }], level: 2, hasConnections: false },
        { id: 6, name: 'Mary Doe', role: 'Grandmother', connections: [{ to: 1, type: 'parent' }], level: 2, hasConnections: false },
        { id: 7, name: 'Emma Wilson', role: 'Cousin', connections: [{ to: 0, type: 'cousin' }], level:1, hasConnections: true }
      ]
    },
    {
      id: 2,
      name: 'Close Friends',
      color: '#4ECDC4',
      members: 6,
      description: 'Closest friends and confidants',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 8, name: 'Alex Brown', role: 'Best Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 9, name: 'Chris Lee', role: 'Childhood Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 10, name: 'Taylor Swift', role: 'College Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: false },
        { id: 11, name: 'David Chen', role: 'Gym Buddy', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 12, name: 'Lisa Park', role: 'Travel Buddy', connections: [{ to: 0, type: 'friend' }], hasConnections: true }
      ]
    },
    {
      id: 3,
      name: 'Friends',
      color: '#45B7D1',
      members: 8,
      description: 'General friends and acquaintances',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 8, name: 'Alex Brown', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 9, name: 'Chris Lee', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 13, name: 'Sam Wilson', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: false },
        { id: 14, name: 'Sarah Johnson', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 15, name: 'Michael Scott', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 16, name: 'Jim Halpert', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 17, name: 'Pam Beesly', role: 'Friend', connections: [{ to: 0, type: 'friend' }], hasConnections: true }
      ]
    },
    {
      id: 4,
      name: 'Prodapt Colleagues',
      color: '#96CEB4',
      members: 10,
      description: 'Current and former Prodapt colleagues',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 18, name: 'Dwight Schrute', role: 'Team Lead', connections: [{ to: 0, type: 'manager' }], hasConnections: true },
        { id: 19, name: 'Angela Martin', role: 'Senior Developer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 20, name: 'Kevin Malone', role: 'Developer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 21, name: 'Oscar Martinez', role: 'Architect', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 22, name: 'Stanley Hudson', role: 'QA Lead', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 23, name: 'Phyllis Vance', role: 'Business Analyst', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 24, name: 'Meredith Palmer', role: 'Product Owner', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 25, name: 'Creed Bratton', role: 'DevOps Engineer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 26, name: 'Kelly Kapoor', role: 'UI/UX Designer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true }
      ]
    },
    {
      id: 5,
      name: 'Aviva Colleagues',
      color: '#FFEEAD',
      members: 8,
      description: 'Current and former Aviva colleagues',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 27, name: 'Ryan Howard', role: 'Project Manager', connections: [{ to: 0, type: 'manager' }], hasConnections: true },
        { id: 28, name: 'Toby Flenderson', role: 'Scrum Master', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 29, name: 'Andy Bernard', role: 'Senior Developer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 30, name: 'Erin Hannon', role: 'Business Analyst', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 31, name: 'Gabe Lewis', role: 'Product Owner', connections: [{ to: 0, type: 'colleague' }], hasConnections: true },
        { id: 32, name: 'Robert California', role: 'Director', connections: [{ to: 0, type: 'manager' }], hasConnections: true },
        { id: 33, name: 'Nellie Bertram', role: 'QA Engineer', connections: [{ to: 0, type: 'colleague' }], hasConnections: true }
      ]
    },
    {
      id: 6,
      name: 'Brighton Trip',
      color: '#D4A5A5',
      members: 6,
      description: 'Friends from the Brighton trip',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 8, name: 'Alex Brown', role: 'Trip Organizer', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 11, name: 'David Chen', role: 'Photographer', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 12, name: 'Lisa Park', role: 'Travel Buddy', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 34, name: 'Pete Miller', role: 'Tour Guide', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 35, name: 'Clark Green', role: 'Local Guide', connections: [{ to: 0, type: 'friend' }], hasConnections: true }
      ]
    },
    {
      id: 7,
      name: 'UK Trip Roamers',
      color: '#88D8B0',
      members: 8,
      description: 'Friends from the UK trip',
      membersData: [
        { id: 0, name: 'You', role: 'Current User', connections: [], level: 0, hasConnections: true },
        { id: 9, name: 'Chris Lee', role: 'Trip Planner', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 10, name: 'Taylor Swift', role: 'Travel Companion', connections: [{ to: 0, type: 'friend' }], hasConnections: false },
        { id: 14, name: 'Sarah Johnson', role: 'Photographer', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 15, name: 'Michael Scott', role: 'Tour Guide', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 16, name: 'Jim Halpert', role: 'Travel Buddy', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 17, name: 'Pam Beesly', role: 'Travel Companion', connections: [{ to: 0, type: 'friend' }], hasConnections: true },
        { id: 18, name: 'Dwight Schrute', role: 'Local Guide', connections: [{ to: 0, type: 'friend' }], hasConnections: true }
      ]
    }
  ],
  currentUser: { id: 0, name: 'You', role: 'Current User', hasConnections: true },
  // Add more simulated users
  allUsers: [
    { id: 15, name: 'Michael Scott', role: 'Regional Manager', hasConnections: true },
    { id: 16, name: 'Jim Halpert', role: 'Sales Representative', hasConnections: true },
    { id: 17, name: 'Pam Beesly', role: 'Receptionist', hasConnections: true },
    { id: 18, name: 'Dwight Schrute', role: 'Assistant to the Regional Manager', hasConnections: true },
    { id: 19, name: 'Angela Martin', role: 'Senior Accountant', hasConnections: true },
    { id: 20, name: 'Kevin Malone', role: 'Accountant', hasConnections: true },
    { id: 21, name: 'Oscar Martinez', role: 'Accountant', hasConnections: true },
    { id: 22, name: 'Stanley Hudson', role: 'Sales Representative', hasConnections: true },
    { id: 23, name: 'Phyllis Vance', role: 'Sales Representative', hasConnections: true },
    { id: 24, name: 'Meredith Palmer', role: 'Supplier Relations', hasConnections: true },
    { id: 25, name: 'Creed Bratton', role: 'Quality Assurance', hasConnections: true },
    { id: 26, name: 'Kelly Kapoor', role: 'Customer Service', hasConnections: true },
    { id: 27, name: 'Ryan Howard', role: 'Temp', hasConnections: true },
    { id: 28, name: 'Toby Flenderson', role: 'HR Representative', hasConnections: true },
    { id: 29, name: 'Andy Bernard', role: 'Sales Representative', hasConnections: true },
    { id: 30, name: 'Erin Hannon', role: 'Receptionist', hasConnections: true },
    { id: 31, name: 'Gabe Lewis', role: 'VP Northeast', hasConnections: true },
    { id: 32, name: 'Robert California', role: 'CEO', hasConnections: true },
    { id: 33, name: 'Nellie Bertram', role: 'Special Projects', hasConnections: true },
    { id: 34, name: 'Pete Miller', role: 'Sales Representative', hasConnections: true },
    { id: 35, name: 'Clark Green', role: 'Sales Representative', hasConnections: true }
  ],
  // Add pending connection requests
  pendingRequests: [
    {
      id: 36,
      name: 'Rachel Green',
      mutualConnections: 2,
      role: 'Fashion Designer'
    },
    {
      id: 37,
      name: 'Monica Geller',
      mutualConnections: 3,
      role: 'Chef'
    },
    {
      id: 38,
      name: 'Joey Tribbiani',
      mutualConnections: 1,
      role: 'Actor'
    }
  ]
};

// Normalize a single circle from the API response format to the service format.
// Members get a synthetic connection to the current user (id=0) so visualization
// components can build a relationship tree.
function normalizeApiCircle(apiCircle) {
  const membersData = [
    { id: 0, name: 'You', role: 'You', connections: [], level: 0, hasConnections: true },
    ...(apiCircle.members_data || []).map(m => ({
      id: m.customer_id,
      name: m.customer_name,
      connections: [{ to: 0 }],
      level: m.zone_level || 1,
      hasConnections: false,
      profile_picture: m.profile_picture,
      username: m.username,
    })),
  ];
  return {
    id: apiCircle.circle_id,
    name: apiCircle.circle_name,
    color: apiCircle.color || '#4ECDC4',
    description: apiCircle.description || '',
    members: apiCircle.member_count || (membersData.length - 1),
    membersData,
  };
}

// In a real application, this would be replaced with API calls
class NetworkDataService {
  constructor() {
    this.data = { ...initialData };
  }

  // Replace in-memory circles with API data
  loadFromAPI(apiCircles) {
    this.data.circles = apiCircles.map(normalizeApiCircle);
  }

  // Sync a single circle update back into the in-memory store
  syncCircleUpdate(circleId, updates) {
    const circle = this.data.circles.find(c => c.id === circleId);
    if (circle) Object.assign(circle, updates);
  }

  syncCircleRemove(circleId) {
    this.data.circles = this.data.circles.filter(c => c.id !== circleId);
  }

  syncCircleAdd(apiCircle) {
    this.data.circles.push(normalizeApiCircle(apiCircle));
  }

  syncMemberAdd(circleId, apiMember) {
    const circle = this.data.circles.find(c => c.id === circleId);
    if (!circle) return;
    const normalized = {
      id: apiMember.customer_id,
      name: apiMember.customer_name,
      connections: [{ to: 0 }],
      level: apiMember.zone_level || 1,
      hasConnections: false,
      profile_picture: apiMember.profile_picture,
      username: apiMember.username,
    };
    const existing = circle.membersData.find(m => m.id === normalized.id);
    if (!existing) {
      circle.membersData.push(normalized);
      circle.members = circle.membersData.filter(m => m.id !== 0).length;
    }
  }

  syncMemberRemove(circleId, customerId) {
    const circle = this.data.circles.find(c => c.id === circleId);
    if (!circle) return;
    circle.membersData = circle.membersData.filter(m => m.id !== customerId);
    circle.members = circle.membersData.filter(m => m.id !== 0).length;
  }

  // Circle operations
  getCircles() {
    return this.data.circles;
  }

  getCircleById(id) {
    return this.data.circles.find(circle => circle.id === id);
  }

  updateCircle(id, updates) {
    const circleIndex = this.data.circles.findIndex(circle => circle.id === id);
    if (circleIndex !== -1) {
      this.data.circles[circleIndex] = {
        ...this.data.circles[circleIndex],
        ...updates
      };
      return this.data.circles[circleIndex];
    }
    return null;
  }

  // Member operations
  getCircleMembers(circleId) {
    const circle = this.getCircleById(circleId);
    return circle ? circle.membersData : [];
  }

  addMemberToCircle(circleId, member) {
    const circle = this.getCircleById(circleId);
    if (circle) {
      const newMember = {
        ...member,
        id: Math.max(...circle.membersData.map(m => m.id)) + 1,
        connections: member.connections || [],
        level: member.level || 1,
        hasConnections: member.hasConnections || false
      };
      circle.membersData.push(newMember);
      circle.members = circle.membersData.length;
      return newMember;
    }
    return null;
  }

  updateMemberInCircle(circleId, memberId, updates) {
    const circle = this.getCircleById(circleId);
    if (circle) {
      const memberIndex = circle.membersData.findIndex(m => m.id === memberId);
      if (memberIndex !== -1) {
        circle.membersData[memberIndex] = {
          ...circle.membersData[memberIndex],
          ...updates
        };
        return circle.membersData[memberIndex];
      }
    }
    return null;
  }

  addRelationship(circleId, fromMemberId, toMemberId, type) {
    const circle = this.getCircleById(circleId);
    if (circle) {
      const fromMember = circle.membersData.find(m => m.id === fromMemberId);
      if (fromMember) {
        // Check if relationship already exists
        const existingConnection = fromMember.connections.find(
          conn => conn.to === toMemberId
        );
        
        if (!existingConnection) {
          fromMember.connections = fromMember.connections || [];
          fromMember.connections.push({ to: toMemberId, type });
          // Update hasConnections when adding a relationship
          fromMember.hasConnections = true;
        }
        return fromMember;
      }
    }
    return null;
  }

  // Current user
  getCurrentUser() {
    return this.data.currentUser;
  }

  // Simulate API call to get connections for a specific member
  async getMemberConnections(circleId, memberId) {
    console.log("Getting connections for member:", memberId, circleId);
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const circle = this.getCircleById(circleId);
    if (!circle) return [];
    
    // Find all members that have a connection to this member
    const connectedMembers = circle.membersData.filter(member => 
      member.connections.some(conn => conn.to === memberId)
    );
    
    // Return in the same format as membersData
    const mem = connectedMembers.map(member => ({
      id: member.id,
      name: member.name,
      role: member.role,
      connections: member.connections.filter(conn => conn.to === memberId),
      level: member.level,
      hasConnections: member.hasConnections
    }));

    console.log("Connections from networkData.js:", mem);
    return mem;
  }

  // Simulate API call to search members
  async searchMembers(circleId, query) {
    console.log("Searching members for query:", query);
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const circle = this.getCircleById(circleId);
    if (!circle) return [];
    
    // Simulate API response with member data format
    const results = circle.membersData.filter(member => 
      member.name.toLowerCase().includes(query.toLowerCase())
    ).map(member => ({
      id: member.id,
      name: member.name,
      role: member.role,
      connections: member.connections,
      level: member.level,
      hasConnections: member.hasConnections
    }));

    return results;
  }

  // Get connection hierarchy between two members
  async getConnectionHierarchy(circleId, fromMemberId, toMemberId) {
    console.log("Getting connection hierarchy between:", fromMemberId, "and", toMemberId);
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const circle = this.getCircleById(circleId);
    if (!circle) return null;
    
    // Helper function to find all connections to a member
    const findConnectionsTo = (memberId) => {
      return circle.membersData.filter(member => 
        member.connections.some(conn => conn.to === memberId)
      );
    };

    // Helper function to build the tree structure
    const buildTree = async (memberId, targetId, visited = new Set()) => {
      if (visited.has(memberId)) return null;
      visited.add(memberId);

      const member = circle.membersData.find(m => m.id === memberId);
      if (!member) return null;

      // If we've reached the target member, return it
      if (memberId === targetId) {
        return {
          id: member.id,
          name: member.name,
          type: member.role,
          description: "Target Member",
          children: [],
          hasChildren: false // Target member is a leaf node
        };
      }

      // Find all members that have a connection to this member
      const connectedMembers = findConnectionsTo(memberId);
      
      // Try to find a path to the target through each connection
      for (const connectedMember of connectedMembers) {
        const path = await buildTree(connectedMember.id, targetId, new Set(visited));
        if (path) {
          // Only include the path member in children, not all connections
          return {
            id: member.id,
            name: member.name,
            type: member.role,
            description: member.connections.find(conn => conn.to === connectedMember.id)?.type || 'connection',
            children: [path],
            hasChildren: true
          };
        }
      }

      return null;
    };

    // Start building the tree from the source member
    const hierarchy = await buildTree(fromMemberId, toMemberId);
    console.log("Connection hierarchy:", hierarchy);
    return hierarchy;
  }

  // Add new method to get common members between circles
  getCommonMembers(circleId1, circleId2) {
    const circle1 = this.getCircleById(circleId1);
    const circle2 = this.getCircleById(circleId2);
    
    if (!circle1 || !circle2) return [];
    
    const circle1MemberIds = new Set(circle1.membersData.map(m => m.id));
    return circle2.membersData.filter(member => circle1MemberIds.has(member.id));
  }

  // Add new method to get common members between all circles
  getAllCommonMembers() {
    const circles = this.data.circles;
    const commonMembers = {};
    
    for (let i = 0; i < circles.length; i++) {
      for (let j = i + 1; j < circles.length; j++) {
        const circle1 = circles[i];
        const circle2 = circles[j];
        const common = this.getCommonMembers(circle1.id, circle2.id);
        commonMembers[`${circle1.id}-${circle2.id}`] = common;
      }
    }
    
    return commonMembers;
  }

  // Add new method to get all users
  getAllUsers() {
    return this.data.allUsers;
  }

  // Add new method to add user to a circle
  addUserToCircle(userId, circleId) {
    console.log('Adding user to circle:', { userId, circleId });
    
    // First try to find the user in pending requests
    let user = this.data.pendingRequests.find(req => req.id === userId);
    console.log('Found in pending requests:', user);
    
    // If not found in pending requests, look in allUsers
    if (!user) {
      user = this.data.allUsers.find(u => u.id === userId);
      console.log('Found in allUsers:', user);
    }

    // If still not found, look in existing circle members
    if (!user) {
      for (const circle of this.data.circles) {
        const member = circle.membersData.find(m => m.id === userId);
        if (member) {
          user = member;
          console.log('Found in circle members:', user);
          break;
        }
      }
    }

    if (!user) {
      console.log('User not found in any source');
      return null;
    }

    const circle = this.getCircleById(circleId);
    if (!circle) {
      console.log('Circle not found:', circleId);
      return null;
    }

    // Check if user is already in the circle
    const existingMember = circle.membersData.find(m => m.id === userId);
    if (existingMember) {
      console.log('User already exists in circle');
      return existingMember;
    }

    console.log('Found user and circle:', { user, circle });

    // Create new member with user data
    const newMember = {
      id: user.id,
      name: user.name,
      role: user.role || 'Member',
      connections: [],
      level: 1,
      hasConnections: false
    };
    
    // Add the member to the circle
    circle.membersData.push(newMember);
    circle.members = circle.membersData.length;
    
    console.log('Added member to circle:', newMember);
    return newMember;
  }

  // Add methods for handling connection requests
  getPendingRequests() {
    return this.data.pendingRequests;
  }

  acceptRequest(requestId, circleId) {
    const request = this.data.pendingRequests.find(req => req.id === requestId);
    if (!request) return null;

    // Add the user to the circle
    const addedMember = this.addUserToCircle(requestId, circleId);
    if (addedMember) {
      // Remove the request from pending requests
      this.data.pendingRequests = this.data.pendingRequests.filter(
        req => req.id !== requestId
      );
      return addedMember;
    }
    return null;
  }

  rejectRequest(requestId) {
    this.data.pendingRequests = this.data.pendingRequests.filter(
      req => req.id !== requestId
    );
    return true;
  }

  // Add new method to update member level
  updateMemberLevel(circleId, memberId, newLevel) {
    const circle = this.getCircleById(circleId);
    if (circle) {
      const memberIndex = circle.membersData.findIndex(m => m.id === memberId);
      if (memberIndex !== -1) {
        circle.membersData[memberIndex] = {
          ...circle.membersData[memberIndex],
          level: newLevel
        };
        return circle.membersData[memberIndex];
      }
    }
    return null;
  }
}

export const networkDataService = new NetworkDataService(); 